



























































import Vue from 'vue'
import BaseImage from '@/common/components/BaseImage.vue'
import ModalSelectAddon from '@/product/components/addonOptions/ModalSelectAddon.vue'
import { ProductState, AddonProduct } from '@/product/types'
import { SVG_PLACEHOLDER_IMAGES } from '@/common/constants'
import { formatOneDecimal } from '@/common/utils/common'

export default Vue.extend({
  components: {
    BaseImage,
    ModalSelectAddon
  },
  props: {
    enableDefaultMessage: {
      type: Boolean,
      default: true
    },
    addonProducts: {
      type: Array as () => AddonProduct[],
      default: () => []
    },
    selectedAddonProductId: {
      type: String || undefined,
      default: undefined
    },
    selectedAddonFirstOptionId: {
      type: String || undefined,
      default: undefined
    },
    outOfStockOptions: {
      type: Object as () => { [key: string]: string },
      required: true
    },
    showHighlightAddonProductSelection: {
      type: Boolean,
      default: false
    }
  },
  data(): {
    showSelectAddonModal: boolean
  } {
    return {
      showSelectAddonModal: false
    }
  },
  computed: {
    placeholder(): string {
      return SVG_PLACEHOLDER_IMAGES.SQUARE
    },
    storeState(): ProductState {
      return this.$store.state
    },
    addonProductName(): string | null {
      return this.storeState.estimate.selectedAddonProductName
    },
    addonProductPrice(): number | undefined {
      return this.storeState.estimate.addonProductUnitPriceTaxIncluded
    }
  },
  methods: {
    formatOneDecimal,
    toggleShowSelectAddonModal(): boolean {
      return this.showSelectAddonModal = !this.showSelectAddonModal
    },
    onUpdateAddonProduct(value: {
      selectedAddonProductId?: string
      selectedAddonFirstOptionId?: string
    }) {
      this.toggleShowSelectAddonModal()
      this.$emit(
        'updateAddonProduct',
        {
          selectedAddonProductId: value.selectedAddonProductId,
          selectedAddonFirstOptionId: value.selectedAddonFirstOptionId
        }
      )
    }
  }
})
